import React from 'react';
import { useRecoilValue } from 'recoil';
import { ImageLoader } from '../../product_detail/components/ImageLoader';
import { isMobileState } from '../../recoil/selectors';
import { assetPathFn, sizeImage } from '../../util';
import { useLanderControls } from '../LanderContext';
import { getURLParam, decodeBase64Url } from '../../util';
import styles from './LanderTopHero.module.scss';
import { Button } from '../../root/components/buttons/Button';
import { abTestState } from '../../recoil/atoms';

export const LanderTopHero: React.FC<{
  title: string;
  titleElement?: React.ReactNode;
  subTitle?: string | React.ReactNode;
  heroImage: string;
  maxHeroContainerHeight?: string;
  heroContainerHeight?: string;
  heroContainerStyle?: React.CSSProperties;
  backgroundColor?: string;
  hideCTA?: boolean;
}> = ({ title, subTitle, heroImage, titleElement, children, maxHeroContainerHeight, heroContainerStyle, backgroundColor, heroContainerHeight, hideCTA }) => {
  const isMobile = useRecoilValue(isMobileState);
  const { scrollToProductSection } = useLanderControls();
  const abTests = useRecoilValue(abTestState);

  // substitute dynamic headlines from query string parameters
  title = getURLParam('h1p') && decodeBase64Url(getURLParam('h1p') || '') ? decodeBase64Url(getURLParam('h1p') || '').replace(/\|/g, ' ') : title;
  subTitle = getURLParam('h1s') && decodeBase64Url(getURLParam('h1s') || '') ? decodeBase64Url(getURLParam('h1s') || '') : subTitle;
  titleElement =
    getURLParam('h1p') && decodeBase64Url(getURLParam('h1p') || '').includes('|') ? (
      <>
        {decodeBase64Url(getURLParam('h1p') || '')
          .split('|')
          .map((v, i) => (
            <div key={`h1p-line-${i}`}>{v}</div>
          ))}
      </>
    ) : (
      titleElement
    );
  if (isMobile) {
    return (
      <>
        <div className={styles.mobileProductLander} style={heroContainerHeight ? { height: heroContainerHeight } : {}}>
          <img className={styles.mobileHero} src={assetPathFn(sizeImage(heroImage, 'x780'))} alt={title} style={backgroundColor ? { backgroundColor } : {}} />
          {children}
        </div>
        <div className={styles.heroContentWrapper} style={{ zIndex: 1 }}>
          <div className={styles.heroText}>{titleElement ?? title}</div>
          {subTitle && <div className={styles.heroSubText}>{subTitle}</div>}
        </div>
      </>
    );
  }
  return (
    <div className={styles.productLander} style={maxHeroContainerHeight ? { maxHeight: maxHeroContainerHeight, height: heroContainerHeight ?? '56vw' } : {}}>
      <ImageLoader className={styles.heroImage} src={assetPathFn(sizeImage(heroImage, 'x1440'))} alt={title} />
      <div className={styles.heroContentWrapper} style={heroContainerStyle ?? heroContainerStyle}>
        <div className={styles.heroText}>{titleElement ?? title}</div>
        <div className={styles.heroSubText}>{subTitle}</div>
        {!hideCTA && !abTests['AB2022-02'] && <Button text="Shop now" onClick={scrollToProductSection} buttonType="transparent" size="large" />}
        {children}
      </div>
    </div>
  );
};

export default LanderTopHero;
